import React from "react";
import CloseButton from "../../shared/icon-cross";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Modal from "../../shared/modal";
// import KellyBlue from "./images/KBB.svg";
import GreenZone from "./images/green-zone.svg";
import RedZone from "./images/red-zone.svg";
import WhiteZone from "./images/white-zone.svg";
import KbbWrapper from "../kbb-image";

const KelleyBlueBookPopup = ({carEgcPrice = 0, vehicleRetailPriceRangeMin, vehicleRetailPriceRangeMax, onClose, kbbValueProvidedOn}) => {
    return (
        <Modal isOpen={true}>
            <div styleName={"styles.wrapper"}>
                <div styleName={"styles.headerWrap"}>
                    <h3>Kelley Blue Book®</h3>
                    <CloseButton type="grey" onClickHandler={onClose}/>
                </div>
                <div styleName={"styles.contentWrapper"}>

                    <p styleName={"styles.description"}>The Kelley Blue Book Price Advisor Chart (TM) provides the average price for a used car in the Australian marketplace.<a href="https://kbb.com.au/priceadvisor"> {"<https://kbb.com.au/priceadvisor/>"}.</a> </p>
                    <p styleName={"styles.description"}> At CARS24, 90% of the cars we sell are below the average market price. </p>
                    <p styleName={"styles.description"}> Most of the cars you’ll find on our website fall into the white zone of the Price Advisor Chart, making them great value and below the average market price. </p>
                    <p styleName={"styles.description"}> We strive to provide you with best value for money, hence about 90% of the cars that we advertise are below the average market price. In rare cases where a car is priced above average market price, we can assure you that it is because of valuable features which puts it in high demand.
                    </p>
                    <KbbWrapper
                        vehicleRetailPriceRangeMin={vehicleRetailPriceRangeMin}
                        vehicleRetailPriceRangeMax={vehicleRetailPriceRangeMax}
                        carEgcPrice={carEgcPrice}
                    />
                    <div styleName={"styles.zoneHeading"}>
                        <p styleName={"styles.zonetitle"}> What is the Kelley Blue Book?</p>
                    </div>
                    <p styleName={"styles.zoneDetail"}>

Kelley Blue Book (KBB) is one of the most trusted sources for valuing cars. KBB provides customers with a comparative guide when purchasing a vehicle of fair-market estimates in the Australian car market.
                    </p>
                    <p styleName={"styles.zoneDetail"}>
KBB’s Price Advisor shows how a particular car compares amongst dealers in the market. The Price Advisor for a particular car shows the typical range and is illustrated by a white, green and red zone.

                    </p>
                    <div styleName={"styles.zoneHeading"}>
                        <img src={GreenZone} />
                        <p styleName={"styles.zonetitle"}>KBB® Typical Dealer Asking Price Range</p>
                    </div>
                    <p styleName={"styles.zoneDetail"}>Updated  monthly,  the  Kelley  Blue  Book®  Typical  Dealer  Asking  Range
                        is  representative  of  dealers’  asking prices for a used car. It
                        assumes that the vehicle has been fully reconditioned and has a
                        clean title  history.  This  price  also  takes  into  account
                        the  dealers’  profit,  costs  for  advertising,  sales commissions
                        and other costs of doing business but excludes applicable tax.
                        The final sale price will likely  be  less,  depending  on  the
                        car’s  actual  condition,  popularity,  type  of  warranty
                        offered  and  local  market factors. In other words, it is the
                        price you should expect a dealer to ask - not always the price
                        you should pay.</p>
                    <div styleName={"styles.zoneHeading"}>
                        <img src={RedZone} />
                        <p styleName={"styles.zonetitle"}>Red Zone</p>
                    </div>
                    <p styleName={"styles.zoneDetail"}>The red zone falls above the Kelley Blue Book® Typical Dealer Asking Price Range. Special circumstances such as exceptionally low supply with high demand, options installed by the dealership, and seasonality may all be contributing factors to sales that occur in this range.</p>
                    <div styleName={"styles.zoneHeading"}>
                        <img src={WhiteZone} />
                        <p styleName={"styles.zonetitle"}>White Zone</p>
                    </div>
                    <p styleName={"styles.zoneDetail"}>The white zone falls below the Kelley Blue Book® Typical Dealer Asking Price Range. Special circumstances such as unpopular color, excess inventory and seasonality may all be contributing factors to sales that occur in this range.</p>
                    <p styleName={"styles.zoneDetail"}>©2021 Kelley Blue Book Co., Inc. All rights reserved. As of {kbbValueProvidedOn || "07/20/2021"} Edition for Victoria. Values and pricing are the opinions of Kelley Blue Book, and the actual price of a vehicle may vary.The value and pricing information displayed for a particular vehicle is based upon the specification, kilometers and/or condition information provided by the person generating this report. Kelley Blue Book assumes no responsibility for errors or omissions.</p>
                </div>
            </div>
        </Modal>
    );
};

KelleyBlueBookPopup.propTypes = {
    onClose: PropTypes.func,
    vehicleRetailPriceRangeMin: PropTypes.number,
    vehicleRetailPriceRangeMax: PropTypes.number,
    kbbValueProvidedOn: PropTypes.string,
    carEgcPrice: PropTypes.number
};

export default KelleyBlueBookPopup;
